<template lang="pug">
  div.access.user-groups.users
    e-toolbar(
    :items="items"
      @deleteItems="deleteItems"
        :hideRemoveButton="true"
        :showCol="false"
        :showViewPanel="false"
        :showAdminUserPanel="true"
        :hideAddUsersGroupsButton="false"
        :hideAddButton="true"
        :showTotal="true"
        :adminUsersShow="false"
        :adminUsersGroupsShow="false"
        :hideImportBtn="true"
    )
    div.admin-users-groups-table
      div.content
        div.table.reestr
          div.table-head
            div Группы пользователей
            div ФИО
            div Активность
            div
          div(v-if="items && items.data").table-body
            template(v-for="item in items.data")
              div(:key="item.id").table-row
                div(
                :class="{'open': openedGroups.indexOf(item.id) > -1, 'close': openedGroups.indexOf(item.id) === -1 }"
                ).item.first-level
                  div(@click="toggleGroup(item.id)").item-cell
                    span.arrow
                    span(v-html="item.name").bold
                  div.item-cell
                  div.item-cell
                  div.item-cell
                    div.buttons
                      button(
                        title="Добавить пользователя"
                        v-if="userCanCreate"
                        @click="addUserToGroup(item)"
                      ).actions-panel__button.green.green--withText.btn-add-user Добавить пользователя
                      button(
                        v-if="userCanEdit"
                        @click="editGroup(item)"
                      ).row-edit
                      button(
                        v-if="userCanDelete"
                        @click="deleteGroup(item)"
                      ).row-delete
              template(v-if="openedGroups.indexOf(item.id) > -1 && item.users && item.users.length")
                div(
                 v-for="user, userIndex in item.users"
                 :key="`user_${user.id}`"
                ).table-row
                  div.item.second-level
                    div.item-cell
                      span.arrow
                      span.bold
                    div.item-cell {{user.fullname}}
                    div.item-cell {{user.is_active ? 'Активен' : 'Не активен'}}
                    div.item-cell
                      div.buttons
                        button(
                          v-if="userCanEdit"
                          @click="editUser(user)"
                        ).row-edit
                        button(
                          v-if="userCanDelete"
                          @click="deleteUser(user)"
                        ).row-delete
              template(v-else-if="openedGroups.indexOf(item.id) > -1")
                div.table-row
                  div.item.second-level
                    div.item-cell
                      span.arrow
                      span.bold
                    div.item-cell В группе {{item.name}} нет пользователей
                    div.item-cell
                    div.item-cell
                      div.buttons
          div(v-else).table-body
            div.table-row
              div.item.second-level
                div.item-cell
                  span.arrow
                  span.bold
                div.item-cell Ничего не найдено
                div.item-cell
                div.item-cell
                  div.buttons

        div.footer-nav
          div.actions-filter-panel
          e-pagination(
              :pageCount="meta.pageCount"
              :currentPage="meta.currentPage"
              :totalCount="meta.totalCount"
              :perPage="meta.perPage"
          )

    router-view
</template>

<script>
  import {access} from '../../api/api-endpoints.js'
  import tableMixin from '../../components/table/table-mixin.js'
  import permissionMixin from '../../mixins/permission-mixin.js'
  import url from '../../utils/url'

  export default {
    mixins: [tableMixin, permissionMixin],
    data () {
      return {
        openedGroups: []
      }
    },
    computed: {
      meta () {
        if (this.items && this.items._meta) {
          return this.items._meta
        }
        return {}
      }
    },
    watch: {
      '$route': 'onRoute'
    },
    created () {
      this.onRoute()
    },
    methods: {
      onRoute () {
        if (this.$route.query && this.$route.query.openUserGroup) {
          this.openedGroups.push(this.$route.query.openUserGroup)
        }
      },
      addUserToGroup (group) {
        this.$router.push({
          name: 'access.users.create',
          query: {
            setFields: JSON.stringify({user_group_id: group.id}),
            prevRoute: url.getRoute(this.$route, true)
          }
        })
      },
      editGroup (group) {
        this.$router.push({
          name: 'access.usersGroups.update',
          params: {id: group.id},
          query: {
            prevRoute: url.getRoute(this.$route, true)
          }
        })
      },
      deleteGroup (group) {
        this.confirmBox('Удаленную запись нельзя будет восстановить', 'Удалить группу?').then(() => {
          this.$store.dispatch('deleteModel', {
            url: access.groupDelete(group.id),
            data: {id: group.id},
            endpoint: this.getEndpoint(this.$route)
          }).then(r => {
            this.showOnSuccess('Группа удалена')
            this.reFetchData()
          }).catch(erResponse => {
            console.error(erResponse)
            this.showOnError(erResponse)
          })
        })
      },
      reFetchData () {
        this.$bar.start()
        this.$store.dispatch('updateUrlEndpoint', {
          endpoint: this.getEndpoint(this.$route)
        }).then(() => {
          this.$bar.finish()
        }).catch(() => {
          this.$bar.finish()
        })
      },
      editUser (user) {
        this.$router.push({
          name: 'access.users.update',
          params: {id: user.id},
          query: {
            prevRoute: url.getRoute(this.$route, true)
          }
        })
      },
      deleteUser (user) {
        this.confirmBox('Удаленную запись нельзя будет восстановить', 'Удалить пользователя?').then(() => {
          this.$store.dispatch('deleteModel', {
            url: access.userDelete(user.id),
            data: {id: user.id},
            endpoint: this.getEndpoint(this.$route)
          }).then(r => {
            this.showOnSuccess('Пользователь удален')
            this.reFetchData()
          }).catch(erResponse => {
            console.error(erResponse)
            this.showOnError(erResponse)
          })
        })
      },
      toggleGroup (groupId) {
        if (this.openedGroups.indexOf(groupId) > -1) {
          this.openedGroups = this.openedGroups.filter(g => g !== groupId)
        } else {
          this.openedGroups.push(groupId)
        }
      },
      getEndpoint (route, fromRoute) {
        return access.groups(route)
      },
      getDeleteUrl (id) {
        return null
      }
    }
  }
</script>
